import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function Chat(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(SvgIcon, { ...rest, "data-tidal": "TidalIllustration", "data-tidal-illustration": "Chat", sx, viewBox, children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M38.25 3.75c1.5913 0 3.1174.63214 4.2426 1.75736C43.6179 6.63258 44.25 8.1587 44.25 9.75v21.7223c.0038.1499-.0375.2975-.1185.4237-.0809.1262-.1979.2253-.3357.2844-.1378.0591-.2902.0755-.4374.0471-.1473-.0283-.2826-.1002-.3887-.2063L39.15 27.351c-.2816-.3444-.6364-.6219-1.0385-.8124-.4021-.1904-.8416-.289-1.2865-.2886H23.25c-1.5913 0-3.1174-.6321-4.2426-1.7574-1.1253-1.1252-1.7574-2.6513-1.7574-4.2426V9.75c0-1.5913.6321-3.11742 1.7574-4.24264C20.1326 4.38214 21.6587 3.75 23.25 3.75h15Z",
        fill: theme.vars.palette.primary.light
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M9.75024 12.75c-1.5913 0-3.11743.6321-4.24264 1.7574-1.12522 1.1252-1.75736 2.6513-1.75736 4.2426v24.7223c-.00377.1499.03749.2975.11845.4237.08096.1262.1979.2253.33572.2844.13783.0591.2902.0755.43745.0471.14725-.0283.28262-.1002.38863-.2063l3.81975-4.6702c.28164-.3444.63637-.6219 1.03849-.8124.40217-.1904.84157-.289 1.28647-.2886h15.075c1.5913 0 3.1175-.6321 4.2427-1.7574 1.1252-1.1252 1.7573-2.6513 1.7573-4.2426v-13.5c0-1.5913-.6321-3.1174-1.7573-4.2426-1.1252-1.1253-2.6514-1.7574-4.2427-1.7574H9.75024Z",
        fill: theme.vars.palette.secondary.main
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M26.25 21.75H9.75c-.19891 0-.38968-.079-.53033-.2197C9.07902 21.3897 9 21.1989 9 21c0-.1989.07902-.3897.21967-.5303.14065-.1407.33142-.2197.53033-.2197h16.5c.1989 0 .3897.079.5303.2197.1407.1406.2197.3314.2197.5303 0 .1989-.079.3897-.2197.5303-.1406.1407-.3314.2197-.5303.2197Zm0 4.5H9.75c-.19891 0-.38968-.079-.53033-.2197C9.07902 25.8897 9 25.6989 9 25.5c0-.1989.07902-.3897.21967-.5303.14065-.1407.33142-.2197.53033-.2197h16.5c.1989 0 .3897.079.5303.2197.1407.1406.2197.3314.2197.5303 0 .1989-.079.3897-.2197.5303-.1406.1407-.3314.2197-.5303.2197Zm0 4.5H9.75c-.19891 0-.38968-.079-.53033-.2197C9.07902 30.3897 9 30.1989 9 30c0-.1989.07902-.3897.21967-.5303.14065-.1407.33142-.2197.53033-.2197h16.5c.1989 0 .3897.079.5303.2197.1407.1406.2197.3314.2197.5303 0 .1989-.079.3897-.2197.5303-.1406.1407-.3314.2197-.5303.2197Z",
        fill: theme.vars.palette.primary.dark
      }
    )
  ] });
}
Chat.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "Chat"
};
validateTidalLicense();
export {
  Chat
};
//# sourceMappingURL=Chat.js.map
